export default "__VITE_ASSET__BKL1MLVX__"